'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ToggleIndeterminateCheckBox = function ToggleIndeterminateCheckBox(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' })
  );
};
ToggleIndeterminateCheckBox = (0, _pure2.default)(ToggleIndeterminateCheckBox);
ToggleIndeterminateCheckBox.displayName = 'ToggleIndeterminateCheckBox';
ToggleIndeterminateCheckBox.muiName = 'SvgIcon';

exports.default = ToggleIndeterminateCheckBox;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/toggle/indeterminate-check-box.js
 ** module id = 2365
 ** module chunks = 0
 **/